/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { useLabels } from '@/hooks/useLabels';

const labelMap = {
  lblRecommended: 'label_recommended',
};

export const RecommendedBadge = () => {
  const { lblRecommended } = useLabels(labelMap);

  return (
    <div className={styles.badgeContainer} data-testid="recommended-badge">
      <div className={styles.badgeV2}>
        <div className={styles.badgeText}>{lblRecommended}</div>
        <div className={styles.badgeContainerEnd} />
        <div className={styles.badgeHashMarks}>
          <div className={styles.badgeHashMark} />
          <div className={styles.badgeHashMark} />
        </div>
      </div>
    </div>
  );
};
